module.exports = __webpack_public_path__ + "img/24.d6b23203.jpg";